
define('text!modules/ui/directives/progress-bar/template.html',[],function () { return '<div class=progressBar><div class=progressBar--main ng-class="{ \'is-animated\' : isAnimated && metric !== 100 }"><span ng-class="{ \'redBar\' : color === \'red\', \'greenBar\' : color === \'green\' }"></span></div><div ng-if=showPercentage class=progressBar--metric>{{ metric }} %</div></div>';});

